import type { ReactNode } from "react";
import type { AccountPatch } from "../../types/account";
import { useServerAnswer } from "../../hooks/useServerAnswer";
import { RefusalSentence } from "./RefusalSentence";

interface ReplacementQuestionProps {
  /** The server's question sentence (`replacement_candidate.question`), shown verbatim. */
  question: string;
  onAnswer: (body: AccountPatch) => Promise<void>;
}

/** 1(b): the replacement question, answered Yes or No (PATCH `replaces` alone). */
export function ReplacementQuestion({ question, onAnswer }: ReplacementQuestionProps): ReactNode {
  const { busy, refusal, run, clear } = useServerAnswer(onAnswer);
  return (
    <div className="account-question">
      <p>{question}</p>
      <button type="button" disabled={busy} onClick={() => void run({ replaces: true })}>
        Yes
      </button>
      <button type="button" disabled={busy} onClick={() => void run({ replaces: false })}>
        No
      </button>
      <RefusalSentence refusal={refusal} onDismiss={clear} />
    </div>
  );
}
